import { Injectable } from '@angular/core';
import { ApiService } from '@nstep-common/core';
import { Any } from '@nstep-common/utils';
import {
	AddBalanceReasonDto,
	BalanceExpirationDateModel,
	ExpirationPeriodsQueryModel,
	OperatorBulkTransactionModel,
	GetOperatorBulkTransactionModel,
	PurchaseBalanceDto,
	PurchaseTransactionsModel
} from '@nstep-public/pages';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OnlineTransactionService {

	private pin = new BehaviorSubject<string>('');
	currentPinValue = this.pin.asObservable();
	constructor(private apiService: ApiService) { }

	getPurchaseBalance(cardNumber: string, locationId: number): Observable<PurchaseBalanceDto> {
		return this.apiService.get(PurchaseBalanceDto, 'transactions/manage/purchase', { params: { card: cardNumber, location: locationId } });
	}

	createPurchaseTransactions(purchase: PurchaseTransactionsModel): Observable<any> {
		return this.apiService.postNoContent('transactions/manage/purchase', purchase );
	}

	getAddBalanceReasons(): Observable<AddBalanceReasonDto[]> {
		return this.apiService.get([AddBalanceReasonDto], 'transactions/manage/add-balance-reasons');
	}

	getBulkTransactions(model: GetOperatorBulkTransactionModel): Observable<any> {
		return this.apiService.get(Any, 'transactions/manage/history', { params: model });
	}

	getExpirationPeriods(model: ExpirationPeriodsQueryModel): Observable<BalanceExpirationDateModel[]> {
		return this.apiService.get([BalanceExpirationDateModel], 'transactions/manage/expiration-periods', { params: model });
	}

	saveEntitlementBulkTransaction(model: OperatorBulkTransactionModel): Observable<any> {
		return this.apiService.postNoContent('transactions/manage/add', model);
	}

	changePin(pin: string): void {
		this.pin.next(pin);
	}

	clearOnlineTransactionsCache(): void {
		this.apiService.invalidateCache('transactions/manage/purchase');
	}

	clearAddBalanceHistoryCache(): void {
		this.apiService.invalidateCache('transactions/manage/history');
	}
}
